/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ReportsImport } from './routes/reports'
import { Route as ImportImport } from './routes/import'
import { Route as CallbackHarvestImport } from './routes/callback/harvest'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const ReportsRoute = ReportsImport.update({
  path: '/reports',
  getParentRoute: () => rootRoute,
} as any)

const ImportRoute = ImportImport.update({
  path: '/import',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const CallbackHarvestRoute = CallbackHarvestImport.update({
  path: '/callback/harvest',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/import': {
      id: '/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof ImportImport
      parentRoute: typeof rootRoute
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsImport
      parentRoute: typeof rootRoute
    }
    '/callback/harvest': {
      id: '/callback/harvest'
      path: '/callback/harvest'
      fullPath: '/callback/harvest'
      preLoaderRoute: typeof CallbackHarvestImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  ImportRoute,
  ReportsRoute,
  CallbackHarvestRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/import",
        "/reports",
        "/callback/harvest"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/import": {
      "filePath": "import.tsx"
    },
    "/reports": {
      "filePath": "reports.tsx"
    },
    "/callback/harvest": {
      "filePath": "callback/harvest.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
